import { render, staticRenderFns } from "./ShopSettingsFieldList.vue?vue&type=template&id=c26d5bb4&"
import script from "./ShopSettingsFieldList.vue?vue&type=script&lang=js&"
export * from "./ShopSettingsFieldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports